import { render } from "./ImpersonateButton.vue?vue&type=template&id=aa2330dc&scoped=true"
import script from "./ImpersonateButton.vue?vue&type=script&lang=js"
export * from "./ImpersonateButton.vue?vue&type=script&lang=js"

import "./ImpersonateButton.vue?vue&type=style&index=0&id=aa2330dc&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa2330dc"]])

export default __exports__